import { useCallback, useEffect, useState } from 'react'

import { checkAnswer, getWhatAlgebraQuestionData, WhatAlgebraOptionModel } from './WhatAlgebra.utils'

interface UseWhatAlgebraReturnType {
  options?: WhatAlgebraOptionModel[]
  formValid: boolean
  answer: boolean[]
  handleCheckAnswer: () => void
  onInputChange: (val?: number) => void
  goToNextQuestion: () => void
}

interface UseWhatAlgebraProps {
  onNextQuestionClick: () => void
  onAnswerStateChange: (value: boolean | null) => void
}

function UseWhatAlgebra({ onAnswerStateChange, onNextQuestionClick }: UseWhatAlgebraProps): UseWhatAlgebraReturnType {
  // eslint-disable-next-line
  const [taskHistory, setTaskHistory] = useState<string[]>([])
  const [options, setOptions] = useState<WhatAlgebraOptionModel[]>([])
  const [answer, setAnswer] = useState<boolean[]>([])

  useEffect(() => {
    setAnswer([])
    setOptions(getWhatAlgebraQuestionData(taskHistory))
  }, [taskHistory])

  const handleCheckAnswer = useCallback((): void => {
    onAnswerStateChange(checkAnswer(options, answer))
  }, [options, answer, onAnswerStateChange])

  const onInputChange = useCallback(
    (index?: number) => {
      if (index === undefined) {
        setAnswer([])
      } else {
        setAnswer((prevState) => {
          const _answer = [...prevState]
          _answer[index] = !_answer[index]
          return _answer
        })
      }

      onAnswerStateChange(null)
    },
    [onAnswerStateChange],
  )

  const goToNextQuestion = useCallback(() => {
    setTaskHistory((prevState) =>
      [
        `${options[0].equation}-${options[1].equation}-${options[2].equation}-${options[3].equation}`,
        ...prevState,
      ].slice(0, 3),
    )
    onNextQuestionClick()
  }, [onNextQuestionClick, options])

  return {
    options,
    formValid: answer.length > 0,
    answer,
    handleCheckAnswer,
    onInputChange,
    goToNextQuestion,
  }
}

export default UseWhatAlgebra
